import { makeStyles, tokens } from '@fluentui/react-components'

// AI Generated
// candidate for clean up and removal of unused styles
const useStyles = makeStyles({
  deleteIcon: {
    color: tokens.colorPaletteRedForeground3,
  },
  toolbar: {
    padding: tokens.spacingVerticalXS,
    minHeight: 'auto',
    flexWrap: 'wrap',
    gap: tokens.spacingHorizontalXXS,
    border: `${tokens.strokeWidthThin} solid ${tokens.colorBrandStroke2}`,
    borderRadius: tokens.borderRadiusMedium,
  },
  grid: {
    width: '100%',
    '--ag-background-color': tokens.colorNeutralBackground1,
    '--ag-foreground-color': tokens.colorNeutralForeground1,
    '--ag-border-color': tokens.colorNeutralStroke2,

    '& .ag-root-wrapper': {
      boxShadow: 'none',
      borderRadius: tokens.borderRadiusMedium,
    },

    /* Checkbox: brand fill + white tick, no gray background (checked + indeterminate) */
    '& .ag-checkbox-input-wrapper.ag-checked, & .ag-header .ag-checkbox-input-wrapper.ag-checked, & .ag-checkbox-input-wrapper.ag-indeterminate, & .ag-header .ag-checkbox-input-wrapper.ag-indeterminate':
      {
        backgroundColor: tokens.colorBrandBackground,
        color: tokens.colorNeutralForegroundOnBrand,
        border: `${tokens.strokeWidthThin} solid ${tokens.colorBrandBackground}`,
        boxSizing: 'border-box',
      },
    '& .ag-checkbox-input-wrapper': {
      border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
      boxSizing: 'border-box',
    },

    '& .ag-header-cell': {
      gap: tokens.spacingHorizontalSNudge,
      padding: `0 ${tokens.spacingHorizontalSNudge}`,
    },

    /* --- Filter popup container --- */
    '& .ag-menu, & .ag-filter-wrapper, & .ag-popup .ag-menu': {
      backgroundColor: tokens.colorNeutralBackground1,
      color: tokens.colorNeutralForeground1,
      border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke2}`,
      borderRadius: tokens.borderRadiusMedium,
      padding: tokens.spacingVerticalS,
    },

    '& .ag-filter-body-wrapper, & .ag-filter': {
      backgroundColor: tokens.colorNeutralBackground1,
      color: tokens.colorNeutralForeground1,
      display: 'flex',
      flexDirection: 'column',
      gap: tokens.spacingVerticalS,
    },

    /* --- Filter inputs & select dropdowns --- */
    '& .ag-filter-body input, & .ag-floating-filter-body input, & .ag-picker-field-wrapper': {
      backgroundColor: tokens.colorNeutralBackground1,
      color: tokens.colorNeutralForeground1,
      border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
      borderRadius: tokens.borderRadiusSmall,
    },

    '& .ag-picker-field-wrapper': {
      display: 'flex',
      alignItems: 'center',
      minHeight: tokens.spacingVerticalXXXL,
      boxSizing: 'border-box',
      cursor: 'pointer',
    },

    /* --- Popup filter dialog inputs (have magnifier icon) --- */
    '& .ag-filter .ag-input-wrapper, & .ag-menu .ag-input-wrapper': {
      display: 'flex',
      alignItems: 'center',
      gap: tokens.spacingHorizontalXS,
      minHeight: tokens.spacingVerticalXXXL,
      boxSizing: 'border-box',
      position: 'relative',
    },

    '& .ag-filter .ag-input-wrapper .ag-icon, & .ag-menu .ag-input-wrapper .ag-icon': {
      position: 'absolute',
      left: tokens.spacingHorizontalS,
      top: '50%',
      transform: 'translateY(-50%)',
      pointerEvents: 'none',
      zIndex: 1,
      flexShrink: 0,
      width: tokens.spacingHorizontalL,
      height: tokens.spacingVerticalL,
    },

    '& .ag-filter .ag-input-field-input, & .ag-menu .ag-input-field-input': {
      paddingLeft: '28px !important',
      lineHeight: tokens.lineHeightBase300,
      minHeight: '30px',
      boxSizing: 'border-box',
      borderRadius: tokens.borderRadiusSmall,
    },

    /* --- Floating filter inputs in the header row (no icon, compact) --- */
    '& .ag-floating-filter .ag-input-field-input': {
      paddingLeft: `${tokens.spacingHorizontalXS} !important`,
      paddingRight: `${tokens.spacingHorizontalXS} !important`,
      lineHeight: tokens.lineHeightBase300,
      minHeight: tokens.spacingVerticalXXL,
      boxSizing: 'border-box',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      fontSize: tokens.fontSizeBase200,
    },

    // '& .ag-floating-filter-button': {
    //   paddingLeft: tokens.spacingHorizontalXXS,
    //   marginLeft: tokens.spacingHorizontalXXS,
    // },

    '& .ag-input-field-input::placeholder': {
      color: tokens.colorNeutralForeground3,
      opacity: 1,
    },

    /**
     * AND/OR condition join — restyled from radio buttons to a segmented pill toggle
     * matching Fluent UI design. The native ag-grid radio inputs are hidden; only
     * the label text is shown. :has(.ag-checked) targets the selected state.
     */
    '& .ag-filter-condition': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 0,
      padding: `${tokens.spacingVerticalS} 0`,
      margin: 0,
    },

    /* Each radio button wrapper becomes a pill segment */
    '& .ag-filter-condition .ag-radio-button': {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: `${tokens.spacingVerticalXXS} ${tokens.spacingHorizontalM}`,
      fontSize: tokens.fontSizeBase200,
      fontWeight: tokens.fontWeightSemibold,
      cursor: 'pointer',
      color: tokens.colorNeutralForeground2,
      backgroundColor: tokens.colorNeutralBackground3,
      border: `${tokens.strokeWidthThin} solid ${tokens.colorNeutralStroke1}`,
      userSelect: 'none',
      transition: 'background-color 0.15s, color 0.15s, border-color 0.15s',
    },

    /* First pill (AND) — rounded left */
    '& .ag-filter-condition .ag-radio-button:first-child': {
      borderRadius: `${tokens.borderRadiusMedium} 0 0 ${tokens.borderRadiusMedium}`,
      borderRight: 'none',
    },

    /* Last pill (OR) — rounded right */
    '& .ag-filter-condition .ag-radio-button:last-child': {
      borderRadius: `0 ${tokens.borderRadiusMedium} ${tokens.borderRadiusMedium} 0`,
    },

    /* Hide the radio circle icon — keep only the label text */
    '& .ag-filter-condition .ag-radio-button .ag-input-wrapper': {
      display: 'none',
    },

    /* Show label inline */
    '& .ag-filter-condition .ag-radio-button .ag-label': {
      margin: 0,
      padding: 0,
      lineHeight: tokens.lineHeightBase200,
    },

    /* Selected state — checked radio button's parent has .ag-checked */
    '& .ag-filter-condition .ag-radio-button:has(.ag-checked)': {
      backgroundColor: tokens.colorBrandBackground,
      color: tokens.colorNeutralForegroundOnBrand,
      borderTopColor: tokens.colorBrandBackground,
      borderBottomColor: tokens.colorBrandBackground,
      borderLeftColor: tokens.colorBrandBackground,
      borderRightColor: tokens.colorBrandBackground,
    },

    /* Ensure the border between pills stays clean when selected */
    '& .ag-filter-condition .ag-radio-button:first-child:has(.ag-checked)': {
      borderRight: 'none',
    },

    '& .ag-filter-condition .ag-radio-button:last-child:has(.ag-checked)': {
      borderLeft: `${tokens.strokeWidthThin} solid ${tokens.colorBrandBackground}`,
    },

    /* --- Filter select/list popup items --- */
    '& .ag-list-item': {
      padding: `${tokens.spacingVerticalXS} ${tokens.spacingHorizontalS}`,
      cursor: 'pointer',
      borderRadius: tokens.borderRadiusSmall,
    },

    '& .ag-list-item:hover, & .ag-list-item.ag-active-item': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
    },
  },
  status: {
    color: tokens.colorBrandForeground1,
    margin: 0,
  },
  titleFooterField: {
    width: '100%',
    '& textarea': {
      fontSize: tokens.fontSizeBase200,
    },
  },
  modalSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
    height: '100%',
  },
  modalGridContainer: {
    flex: 1,
    overflow: 'auto',
    minHeight: '40vh',
    maxHeight: '60vh',
  },
})

export { useStyles }
